import React from "react";
import { Image } from "react-bootstrap";
import { fetchStreamGuysMeta, fetchKugsProgram } from "../services/DataService";
import "../style/kugsplayer.scss";

const REFRESH_INTERVAL_MS = 10000;

const artist_image = require("../images/artist.png");
const album_image = require("../images/album.png");
const title_image = require("../images/title.png");

class KUGSPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      play: false,
      pause: true,
    };
    this.url = "https://peridot.streamguys1.com:7175/kugs-mp3";
    this.audio = new Audio(this.url);
    this.audio.crossOrigin = "anonymous";
    const context = new AudioContext();
    const src = context.createMediaElementSource(this.audio);
    this.analyser = context.createAnalyser();
    src.connect(this.analyser);
    this.analyser.connect(context.destination);
  }

  componentDidMount() {
    this.getNowPlaying();
    setInterval(this.getNowPlaying, REFRESH_INTERVAL_MS);
  }

  mute = () => {
    document.getElementById("muteButton").style.display = "none";
    document.getElementById("unmuteButton").style.display = "block";
    this.audio.muted = true;
  };

  unmute = () => {
    document.getElementById("unmuteButton").style.display = "none";
    document.getElementById("muteButton").style.display = "block";
    this.audio.muted = false;
  };

  stop = () => {
    document.getElementById("stopButton").style.display = "none";
    document.getElementById("playButton").style.display = "block";
    this.setState({ play: false, pause: true });
    this.audio.pause();
  };

  play = () => {
    this.setState({ play: true, pause: false });
    this.audio.play();
    document.getElementById("playButton").style.display = "none";
    document.getElementById("stopButton").style.display = "block";

    const canvas = document.getElementById("canvas");
    const pumps = document.getElementsByClassName("pump");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const ctx = canvas.getContext("2d");

    this.analyser.fftSize = 16384;
    const bufferLength = this.analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    const WIDTH = canvas.width;
    const HEIGHT = canvas.height;
    const barWidth = (WIDTH / bufferLength) * 27;
    let barHeight;
    let x = 0;

    let renderFrame = () => {
      requestAnimationFrame(renderFrame);
      x = 10;

      this.analyser.getByteFrequencyData(dataArray);
      ctx.fillStyle = "rgba(0,0,0,1)"; // Clears canvas before rendering bars (black with opacity 0.2)
      ctx.fillRect(0, 0, WIDTH, HEIGHT); // Fade effect, set opacity to 1 for sharper rendering of bars

      let a;
      let bars = 118;
      let total = 0;

      for (let i = 0; i < bars; i++) {
        barHeight = dataArray[i] * 2.5;
        if (dataArray[i] > 210) {
          a = 1.0;
        } else {
          a = dataArray[i] / 210;
        }

        ctx.fillStyle = `rgb(193,39,45,${a})`;
        ctx.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);

        x += barWidth + 10;
        total += dataArray[i];
      }
      let max = 21000;
      let opacity = 1.0;
      if (total < max) {
        opacity = total / max;
      }
      if (opacity < 0.1) {
        opacity = 0.1;
      }
      for (let pump of pumps) {
        pump.setAttribute("style", `opacity:${opacity}`);
      }
    };

    renderFrame();
  };

  metadataCallback = (data) => {
    let metadata = data.substring(
      data.lastIndexOf('<td>Current Song:</td><td class="streamdata">') + 45
    );
    metadata = metadata.substring(0, metadata.indexOf("</td>")).split(" - ");
    document.getElementById("song").innerText = metadata[0];
    document.getElementById("artist").innerText = metadata[1];
    document.getElementById("album").innerText = metadata[2];
  };

  programmingCallback = (data) => {
    let current;
    let now = Date.now();
    data.forEach(function (program) {
      var start = Date.parse(program.start_time_utc + " UTC");
      var end = Date.parse(program.end_time_utc + " UTC");
      if (start < now && now < end) {
        current = program;
      }
    });
    if (current) {
      document.getElementById("program").innerText = current.name;
      let style =
        current.program_type === "MU" ? "display:block" : "display:none";
      document.getElementById("song").style = style;
      document.getElementById("artist").style = style;
      document.getElementById("album").style = style;
    }
  };

  getNowPlaying = () => {
    fetchKugsProgram(this.programmingCallback);
    fetchStreamGuysMeta(this.metadataCallback);
  };

  render() {
    return (
      <div className="kugs-player">
        <div id="info">
          <div id="program"> </div>
          <Image
            className="pump icon title-icon"
            src={title_image}
            alt="Program"
          />
          <div id="song"> </div>
          <Image
            className="pump icon artist-icon"
            src={artist_image}
            alt="Artist"
          />
          <div id="artist"> </div>
          <Image
            className="pump icon album-icon"
            src={album_image}
            alt="Album"
          />
          <div id="album"> </div>
          <button id="playButton" aria-label="Play" onClick={this.play}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 26.458333 26.458334"
              version="1.1"
              id="svg8"
            >
              <defs id="defs2">
                <linearGradient id="linearGradientPlay" paint="solid">
                  <stop offset="0" id="play-lg-stop" />
                </linearGradient>
              </defs>
              <g id="play-path" transform="translate(0,-270.54165)">
                <path
                  id="path2303"
                  d="m 2.645833,292.41727 0,-18.73896 16.228409,9.36948 z"
                  transform="matrix(1.0955758,0,0,0.94762707,2.9778727e-7,15.554758)"
                />
              </g>
            </svg>
          </button>
          <button id="stopButton" aria-label="Stop" onClick={this.stop}>
            <svg
              id="svg8"
              version="1.1"
              viewBox="0 0 26.458333 26.458334"
              height="40"
              width="40"
            >
              <defs id="defs2">
                <linearGradient paint="solid" id="linearGradientStop">
                  <stop id="stop2297" offset="0" />
                </linearGradient>
              </defs>
              <g transform="translate(0,-270.54165)" id="layer1">
                <path
                  transform="matrix(1.0141328,0,0,1.0136032,-2.6261557e-7,-4.0401446)"
                  d="m 23.450985,294.35414 -20.8051514,0 -10e-8,-20.80515 20.8051515,0 z"
                  id="stop-path"
                />
              </g>
            </svg>
          </button>
          <div id="volume-controls">
            <button id="muteButton" aria-label="Mute" onClick={this.mute}>
              <svg
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#000000"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z" />
              </svg>
            </button>
            <button id="unmuteButton" aria-label="Unmute" onClick={this.unmute}>
              <svg height="24px" viewBox="0 0 24 24" width="24px">
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06c1.34-.3 2.57-.92 3.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l.88-.88L10 11.41v3.76zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z" />
              </svg>
            </button>
          </div>
        </div>

        <div id="background"></div>
      </div>
    );
  }
}

export default KUGSPlayer;
